import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  Avatar,
  IconButton,
  useMediaQuery,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import {
  Edit as EditIcon,
  PhotoCamera,
  WorkspacePremium as WorkspacePremiumIcon,
  AttachMoney as AttachMoneyIcon,
  BusinessCenter as BusinessCenterIcon,
  Star as StarIcon,
  Person,
  Email,
  CreditCard,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import SnackBar from "./SnackBar";
import "../App.css";
import {
  get_profile_data,
  update_profile_data,
  get_smtp_settings, get_user_plan,
  save_smtp_settings,
  delete_smtp_settings,
  create_razorpay_order,
  verify_payment
} from "../Api service/APIvariables";

const sharedInputStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    height: "56px",
    minHeight: "56px",
    boxSizing: "border-box",
  },
  "& .MuiAutocomplete-inputRoot": {
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    paddingLeft: "0px !important",
  },
  "& .MuiOutlinedInput-input": {
    paddingLeft: "14px !important",
  },
  "& label": { 
    fontSize: "14px",
  },
};

export default function Profile() {
  const [mail_from, setMailFrom] = useState("");
  const [mail_host, setMailHost] = useState("");
  const [mail_port, setMailPort] = useState(465);
  const [mail_username, setMailUsername] = useState("");
  const [mail_password, setMailPassword] = useState("");
  const [showAppPassword, setShowAppPassword] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("Default Plan"); // Track selected plan
  const isMobile = useMediaQuery("(max-width: 768px)"); // Detect mobile screens
  const [userDetails, setUserDetails] = useState({
    name: "Add your name",
    email: "Add your Email-id",
    mobile: "Add your Mobile No.",
    company_name: "Add your Company Name",

    image: null, // Placeholder for the uploaded image
  });

  const [editUserDetails, setEditUserDetails] = useState({
    name: "Add your name",
    email: "Add your Email-id",
    mobile: "Add your Mobile No.",
    company_name: "Add your Company Name",
  });

  const [editDetails, setEditDetails] = useState({
    name: "",
    email: "",
    mobile: "",
    company_name: "",
  });

  const [profileImage, setProfileImage] = useState(null);

  const [isEditing, setIsEditing] = useState(false);

  const [userPlan, setUserPlan] = useState(null);
  const navigate = useNavigate();

  const fetchUserPlan = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");
      if (!user_id || !token) return;

      const formData = new FormData();
      formData.append("user_id", user_id);

      const res = await fetch(get_user_plan, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (!data.error) {
        setUserPlan(data);
      }
    } catch (err) {}
  };

  // Tab
  const [tabIndex, setTabIndex] = useState(0);
  const [emailTabIndex, setEmailTabIndex] = useState(0);
  const [sendTestEmail, setSendTestEmail] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  // SnackBar
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");

  const tabRefs = useRef([]);
  const [tabStyles, setTabStyles] = useState({ width: 0, left: 0 });

  useEffect(() => {
    const currentTab = tabRefs.current[tabIndex];
    if (currentTab) {
      const { offsetWidth, offsetLeft, width } = currentTab;

      setTabStyles({
        width: offsetWidth,
        left: offsetLeft,
      });
    }
  }, [tabIndex, isMobile]);

  const fetchProfileData = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");

      if (!user_id || !token) {
        console.error("User ID or token is missing.");
        return;
      }

      const formData = new FormData();
      formData.append("user_id", user_id);

      const response = await fetch(get_profile_data, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch user profile");
      }

      const result = await response.json();

      if (result?.data) {
        setUserDetails({
          name: result.data.name || "Add your name",
          email: result.data.email || "Add your Email-id",
          mobile: result.data.mobile || "Add your Mobile No.",
          company_name: result.data.company_name || "Add your Company Name",
          company_name: result.data.company_name || "Add your Company Name",
          image: result.data.image || null, // Handle image if it's returned
        });
        setEditUserDetails({
          name: result.data.name || "Add your name",
          email: result.data.email || "Add your Email-id",
          mobile: result.data.mobile || "Add your Mobile No.",
          company_name: result.data.company_name || "Add your Company Name",
          image: result.data.image || null, // Handle image if it's returned
        });
        setEditDetails({
          name: result.data.name || "",
          email: result.data.email || "",
          mobile: result.data.mobile || "",
          company_name: result.data.company_name || "",
        });
        // We can add a simple is_pro field
        setUserDetails((prev) => ({ ...prev, is_pro: result.data.is_pro || 0 }));
      } else {
        console.warn("No user data found:", result.message);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const fetchSmtpSettings = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");

      if (!user_id || !token) return;

      let userRole = "user";
      try {
        const authVal = localStorage.getItem("auth");
        const authObj = authVal ? JSON.parse(authVal) : null;
        if (authObj && authObj.role) {
          userRole = authObj.role;
        }
      } catch (e) {}

      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("role", userRole); // Or appropriate role

      const response = await fetch(get_smtp_settings, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to fetch SMTP settings");

      const result = await response.json();
      if (result.success !== false && result.data) {
        setMailFrom(result.data.mail_from || "");
        setMailHost(result.data.mail_host || "");
        setMailPort(result.data.mail_port || 465);
        setMailUsername(result.data.mail_username || "");
        setMailPassword(result.data.mail_password || "");
      }
    } catch (error) {
      console.error("Error fetching SMTP settings:", error);
    }
  };

  useEffect(() => {
    fetchUserPlan();
    fetchProfileData();
    fetchSmtpSettings();
  }, []);

  const updateProfileData = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");

      if (!user_id || !token) {
        console.error("User ID or token is missing.");
        return;
      }

      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("name", editDetails.name);
      formData.append("email", editDetails.email);
      formData.append("mobile", editDetails.mobile);
      formData.append("company_name", editDetails.company_name);
      if (profileImage) {
        formData.append("image", profileImage);
      }

      const response = await fetch(update_profile_data, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to update profile");
      }

      const result = await response.json();

      if (!result?.error) {
        setUserDetails(editDetails);
        setMessage(result.message || "Profile updated successfully");
        setOpen(true);
        setStatus(true);
        setColor(true);
        fetchProfileData();
        setIsEditing(false); // Also stop editing mode
      } else {
        setMessage(result.message || "Failed to update profile");
        setOpen(true);
        setStatus(false);
        setColor(false);
        console.error("Failed to update profile:", result.message);
      }
    } catch (error) {
      setMessage("Error updating profile");
      setOpen(true);
      setStatus(false);
      setColor(false);
      console.error("Error updating profile:", error);
    }
  };

  const handleSaveSmtpSettings = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");

      if (!user_id || !token) return;

      let userRole = "user";
      try {
        const authVal = localStorage.getItem("auth");
        const authObj = authVal ? JSON.parse(authVal) : null;
        if (authObj && authObj.role) {
          userRole = authObj.role;
        }
      } catch (e) {}

      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("role", userRole); // Adjust if roles are dynamic
      formData.append("mail_from", mail_from);
      formData.append("mail_host", mail_host);
      formData.append("mail_port", mail_port);
      formData.append("mail_username", mail_username);
      if (mail_password) {
        formData.append("mail_password", mail_password);
      }

      const response = await fetch(save_smtp_settings, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (!result.error) {
        setMessage("SMTP Settings updated successfully");
        setOpen(true);
        setStatus(true);
        setColor(true);
        fetchSmtpSettings(); // Re-fetch to ensure the input field reflects the saved (and decrypted) password
      } else {
        setMessage(result.message || "Failed to update SMTP Settings");
        setOpen(true);
        setStatus(false);
        setColor(false);
      }
    } catch (error) {
      console.error("Error saving SMTP settings:", error);
      setMessage("Error updating SMTP Settings");
      setOpen(true);
      setStatus(false);
      setColor(false);
    }
  };

  const handleDeleteSmtpSettings = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");

      if (!user_id || !token) return;

      let userRole = "user";
      try {
        const authVal = localStorage.getItem("auth");
        const authObj = authVal ? JSON.parse(authVal) : null;
        if (authObj && authObj.role) {
          userRole = authObj.role;
        }
      } catch (e) {}

      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("role", userRole);

      const response = await fetch(delete_smtp_settings, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (!result.error) {
        setMessage("SMTP Settings deleted successfully");
        setOpen(true);
        setStatus(true);
        setColor(true);
        // Clear fields
        setMailFrom("");
        setMailHost("");
        setMailPort(465);
        setMailUsername("");
        setMailPassword("");
      } else {
        setMessage(result.message || "Failed to delete SMTP Settings");
        setOpen(true);
        setStatus(false);
        setColor(false);
      }
    } catch (error) {
      console.error("Error deleting SMTP settings:", error);
      setMessage("Error deleting SMTP Settings");
      setOpen(true);
      setStatus(false);
      setColor(false);
    }
  };

  const handleTabChange = (newIndex) => {
    setTabIndex(newIndex);
  };

  const handleEmailTabChange = (emailIndex) => {
    setEmailTabIndex(emailIndex);
  };

  console.log(userDetails.mobile);

  const [errors, setErrors] = useState({});

  const handleEditClick = () => {
    setEditDetails(userDetails);
    setErrors({});
    setOpenEditDialog(true);
  };

  const validateFields = () => {
    const newErrors = {};
    Object.keys(editDetails).forEach((key) => {
      if (!editDetails[key]?.toString().trim() && key !== "image") {
        newErrors[key] = "This field is required.";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    // Add logic to handle authentication or submission
    alert("Submitted successfully!");
  };

  const handleSendTestEmailSubmit = () => {};

  const handleSave = () => {
    // Perform validation and save logic here
    if (!editDetails.name.trim()) {
      setErrors({ name: "Name is required" });
      return;
    }
    // setUserDetails(editDetails);
    updateProfileData();
    // fetchProfileData();

    setIsEditing(false);
    setErrors({});
  };

  const handleCancel = () => {
    setOpenEditDialog(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditDetails({ ...editDetails, [name]: value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
      const reader = new FileReader();
      reader.onload = () => {
        setUserDetails((prevDetails) => ({
          ...prevDetails,
          image: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEdit = () => {
    setIsEditing(true); // Enable text fields
  };

  const handlePlanSelection = (plan) => {
    setSelectedPlan(plan);
  };

  const handleMailFromChange = (e) => {
    const value = e.target.value;
    setMailFrom(value);
    
    const email = value.toLowerCase();
    
    // Auto-fill username with the full email address
    setMailUsername(value);

    if (email.includes("@gmail.com")) {
      setMailHost("smtp.gmail.com");
      setMailPort(465); // Or 587
    } else if (email.includes("@yahoo.com")) {
      setMailHost("smtp.mail.yahoo.com");
      setMailPort(465);
    } else if (email.includes("@outlook.com") || email.includes("@hotmail.com")) {
      setMailHost("smtp-mail.outlook.com");
      setMailPort(587);
    } else if (email.includes("@office365.com")) {
      setMailHost("smtp.office365.com");
      setMailPort(587);
    }
  };

  return (
    <>
      <SnackBar
        open={open}
        message={message}
        setOpen={setOpen}
        status={status}
        color={color}
      />
    <div
      className="profile"
      style={{
        display: "flex",
        backgroundColor: "#eceff1",
        minHeight: "100vh",
        position: "relative",
        width: "100%",
        margin: "0 auto",
        paddingLeft: "20px",
        paddingRight: isMobile ? "15px" : "0px",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingTop: "20px",
      }}
    >
      {/* Profile Card */}
      <Box
        sx={{
          position: "relative",
          width: "92%",
          backgroundColor: "white",
          marginTop: "40px",
          marginBottom: "40px",
          borderRadius: "12px",
          padding: 4,
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            height: "100%",
            // backgroundColor: "red",
          }}
        >
          <div style={{ display: "flex" }}>
            {/* Avatar Content */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                mr: isMobile ? 3 : 4,
              }}
            >
              <Avatar
                sx={{
                  width: isMobile ? "70px" : "100px",
                  height: isMobile ? "70px" : "100px",
                  borderRadius: "4px",
                  // border: "1px solid #e0e0e0",
                  cursor: "pointer",
                }}
                src={
                  !userDetails.image 
                    ? "https://via.placeholder.com/100" 
                    : (userDetails.image.startsWith("data:") 
                        ? userDetails.image 
                        : `http://localhost/Quickcard/quickcard_api-main/${userDetails.image}`)
                }
                alt="Profile Picture"
              >
                <IconButton
                  component="label"
                  sx={{
                    position: "absolute",
                    // bottom: 0,
                    // right: 0,
                    width: isMobile ? "50px" : "100%",
                    height: isMobile ? "50px" : "100%",
                    borderRadius: 0,
                    backgroundColor: "transparent",
                    // boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                    "&:hover": { backgroundColor: "#eceff1" },
                  }}
                >
                  <PhotoCamera />
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    onChange={handleImageUpload}
                  />
                </IconButton>
              </Avatar>
            </Box>
            <Box
              sx={{
                display: "block",
                width: "auto",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: isMobile ? "18px" : "22px",
                  fontWeight: "bold",
                  display: "block",
                  alignItems: "center",
                  textAlign: { xs: "left", sm: "left" },
                }}
              >
                {userDetails.name}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  textAlign: { xs: "left", sm: "left" },
                  fontSize: isMobile ? "12px" : "16px",
                  overflow: "hidden",
                  flexShrink: 0,
                  wordBreak: "break-word",
                }}
              >
                {userDetails.email}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  textAlign: { xs: "left", sm: "left" },
                  fontSize: isMobile ? "12px" : "15px",
                }}
              >
                {userDetails.mobile}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  textAlign: { xs: "left", sm: "left" },
                  fontSize: isMobile ? "12px" : "15px",
                }}
              >
                {userDetails.company_name}
              </Typography>
            </Box>
          </div>
          {/* Tabs */}
          <div
            style={{
              display: "flex",
              flexShrink: 0,
              justifyContent: isMobile ? "center" : "flex-end",
              alignItems: "center",
              width: "100%",
              height: "auto",
              marginTop: isMobile ? "20px" : "0",
            }}
          >
            {isMobile ? (
              <Select
                value={tabIndex}
                onChange={(e) => handleTabChange(e.target.value)}
                fullWidth
                sx={{ 
                  backgroundColor: "#eceff1", 
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  fontWeight: "bold"
                }}
              >
                <MenuItem value={0}>Profile</MenuItem>
                <MenuItem value={1}>Email Config</MenuItem>
                <MenuItem value={2}>Subscription</MenuItem>
              </Select>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 20,
                  backgroundColor: "#eceff1",
                  width: "auto",
                  height: "50px",
                  padding: 10,
                  borderRadius: "6px",
                  justifyContent: "space-between",
                  alignItems: "stretch",
                }}
              >
                <div
                  onClick={() => handleTabChange(0)}
                  style={{
                    cursor: "pointer",
                    fontSize: "16px",
                    backgroundColor: tabIndex === 0 ? "#453c72" : "#eceff1",
                    color: tabIndex === 0 ? "white" : "black",
                    padding: "0 16px",
                    borderRadius: "6px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Profile
                </div>
                <div
                  onClick={() => handleTabChange(1)}
                  style={{
                    fontSize: "16px",
                    cursor: "pointer",
                    backgroundColor: tabIndex === 1 ? "#453c72" : "#eceff1",
                    color: tabIndex === 1 ? "white" : "black",
                    padding: "0 16px",
                    borderRadius: "6px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Email Config
                </div>
                <div
                  onClick={() => handleTabChange(2)}
                  style={{
                    fontSize: "16px",
                    cursor: "pointer",
                    backgroundColor: tabIndex === 2 ? "#453c72" : "#eceff1",
                    color: tabIndex === 2 ? "white" : "black",
                    padding: "0 16px",
                    borderRadius: "6px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Subscription
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          {/* Content Below Tabs */}
          <Box sx={{ marginTop: 2 }}>
            {tabIndex === 0 && (
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    display: "flex",
                    fontWeight: "bold",
                    fontSize: isMobile ? "22px" : "26px",
                    color: "#453c72",
                    mt: isMobile ? 3 : 0,
                    mb: 3,
                    justifyContent: "center",
                  }}
                >
                  Edit Profile
                </Typography>
                <Box>
                  {/* Grid container for textfields */}
                  <Grid container spacing={2}>
                    {Object.keys(editDetails)
                      .filter((key) => key !== "image")
                      .map((key) => (
                        <Grid item xs={12} sm={6} key={key}>
                          <TextField
                            autoFocus={key === "name"}
                            margin="dense"
                            label={key.charAt(0).toUpperCase() + key.slice(1)}
                            type="text"
                            fullWidth
                            name={key}
                            value={editDetails[key]}
                            onChange={handleChange}
                            error={Boolean(errors[key])}
                            helperText={errors[key] || ""}
                            disabled={!isEditing}
                          />
                        </Grid>
                      ))}
                  </Grid>

                  {/* Submit button on a new line */}
                  <Box
                    sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
                  >
                    {!isEditing && (
                      <Button
                        onClick={handleEdit}
                        variant="contained"
                        style={{
                          backgroundColor: "#453c72",
                          textTransform: "none",
                          marginRight: "20px",
                        }}
                      >
                        Edit
                      </Button>
                    )}
                    <Button
                      onClick={handleSave}
                      variant="contained"
                      style={{
                        backgroundColor: "#453c72",
                        textTransform: "none",
                      }}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}

            {tabIndex === 1 && (
              <Box>
                {" "}
                <Box
                  sx={{
                    padding: "24px",
                    background: "white", // Gradient background
                    borderRadius: "12px",
                    // border: "1px solid #CFD8DC",
                    // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    width: "100%",
                    margin: "20px auto",
                    mt: isMobile ? 0 : 3,
                    mb: isMobile ? 10 : 0,
                  }}
                >
                  {/* <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      textAlign: "left",
                      // color: "#453c72", // Subtle color for header
                    }}
                  >
                    Email Config
                  </Typography> */}
                  <div
                    style={{
                      display: "flex",
                      flexShrink: 0,
                      justifyContent: "flex-start",
                      alignItems: "center",
                      height: "auto",
                      // backgroundColor: "black",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: 20,
                        backgroundColor: "white",
                        width: "auto",
                        // height: "50px",
                        padding: 10,
                        borderRadius: "6px",
                        justifyContent: "center",
                        alignItems: "center",
                        // marginTop: isMobile ? "10px" : "0px",
                        // marginBottom: isMobile ? "20px" : "0px",
                      }}
                    >
                      <div
                        onClick={() => handleEmailTabChange(0)}
                        style={{
                          cursor: "pointer",
                          fontSize: isMobile ? "12px" : "16px",
                          backgroundColor:
                            emailTabIndex === 0 ? "#453c72" : "white",
                          color: emailTabIndex === 0 ? "white" : "black",
                          padding: emailTabIndex === 0 ? "6px" : "0px",
                          borderRadius: "6px",
                          flexShrink: 0,
                        }}
                      >
                        Email Config
                      </div>
                      {window.location.pathname.startsWith('/admin') && (
                        <div
                          onClick={() => handleEmailTabChange(1)}
                          style={{
                            fontSize: isMobile ? "12px" : "16px",
                            cursor: "pointer",
                            backgroundColor:
                              emailTabIndex === 1 ? "#453c72" : "white",
                            color: emailTabIndex === 1 ? "white" : "black",
                            padding: emailTabIndex === 1 ? "6px" : "0px",
                            borderRadius: "6px",
                            flexShrink: 0,
                          }}
                        >
                          Send Test Email
                        </div>
                      )}
                    </div>
                  </div>

                  {emailTabIndex === 0 && (
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="MAIL_FROM"
                          variant="outlined"
                          fullWidth
                          value={mail_from}
                          onChange={handleMailFromChange}
                          autoComplete="new-password"
                          sx={sharedInputStyles}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          freeSolo
                          options={[
                            "smtp.gmail.com",
                            "smtp.office365.com",
                            "smtp.mail.yahoo.com",
                            "smtp.sendgrid.net",
                            "smtp.mailgun.org"
                          ]}
                          value={mail_host}
                          onChange={(event, newValue) => setMailHost(newValue || "")}
                          onInputChange={(event, newInputValue) => setMailHost(newInputValue || "")}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="MAIL_HOST"
                              variant="outlined"
                              sx={sharedInputStyles}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Autocomplete
                          freeSolo
                          options={["465", "587", "25"]}
                          value={String(mail_port)}
                          onChange={(event, newValue) => setMailPort(newValue || "")}
                          onInputChange={(event, newInputValue) => setMailPort(newInputValue || "")}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="MAIL_PORT"
                              variant="outlined"
                              sx={sharedInputStyles}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="MAIL_USERNAME"
                          variant="outlined"
                          fullWidth
                          value={mail_username}
                          onChange={(e) => setMailUsername(e.target.value)}
                          autoComplete="new-password"
                          sx={sharedInputStyles}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label={mail_host === "smtp.gmail.com" ? "APP_PASSWORD" : "MAIL_PASSWORD"}
                          variant="outlined"
                          type={showAppPassword ? "text" : "password"}
                          fullWidth
                          value={mail_password}
                          onChange={(e) => setMailPassword(e.target.value)}
                          autoComplete="new-password"
                          sx={sharedInputStyles}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => setShowAppPassword(!showAppPassword)}
                                  edge="end"
                                  sx={{ padding: "8px", marginTop: "2px" }}
                                >
                                  {showAppPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {mail_host === "smtp.gmail.com" && (
                          <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary', textAlign: 'left', pl: 1 }}>
                            How to create an app password? <a href="https://support.google.com/mail/answer/185833?hl=en" target="_blank" rel="noopener noreferrer" style={{ color: '#453c72', fontWeight: 'bold' }}>Click here</a> to know more.
                          </Typography>
                        )}
                      </Grid>

                      {/* Second Row: Submit Button */}
                      <Grid item xs={12}>
                        <Box
                          sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
                        >
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={handleDeleteSmtpSettings}
                            sx={{
                              mt: 0,
                              position: "relative",
                              fontSize: "14px",
                              right: "10px",
                              textTransform: "none",
                              borderRadius: "4px",
                            }}
                          >
                            Delete
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSaveSmtpSettings}
                            sx={{
                              mt: 0,
                              position: "relative",
                              fontSize: "14px",
                              right: "10px",
                              textTransform: "none",
                              borderRadius: "4px",
                              backgroundColor: "#453c72", // Same color as Edit Profile button
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            Update
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                  {emailTabIndex === 1 && window.location.pathname.startsWith('/admin') && (
                    <Grid container spacing={2} sx={{ alignItems: "center" }}>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{
                          display: "flex",
                          gap: "50px",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          label="Email-Id*"
                          variant="outlined"
                          type="Email"
                          fullWidth
                          value={sendTestEmail} // Make sure this state is used properly
                          onChange={(e) => setSendTestEmail(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "4px", // Rounded input corners
                            },
                            "& label": { fontSize: "14px" },
                          }}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSendTestEmailSubmit}
                          sx={{
                            mt: 1,
                            width: "auto",
                            position: "relative",
                            fontSize: isMobile ? "10px" : "14px",
                            // right: "10px",
                            textTransform: "none",
                            borderRadius: "4px",
                            backgroundColor: "#453c72",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            whiteSpace: "nowrap",
                            padding: "8px 16px",
                          }}
                        >
                          Send Email
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </Box>
            )}
            {tabIndex === 2 && (
              <Box>
                <Box
                  sx={{
                    padding: "24px",
                    background: "white",
                    borderRadius: "12px",
                    width: "100%",
                    margin: "20px auto",
                    mt: isMobile ? 0 : 3,
                    mb: isMobile ? 10 : 0,
                    flexShrink: 0,
                  }}
                >
                  <Box sx={{ textAlign: "center", mb: 4 }}>
                    {userPlan ? (
                      <Box sx={{ 
                        maxWidth: "800px", 
                        margin: "0 auto 32px auto", 
                        padding: 4, 
                        borderRadius: 2, 
                        backgroundColor: "#fff", 
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
                        border: "1px solid #e0e0e0",
                        textAlign: "left"
                      }}>
                        <Typography variant="h6" fontWeight="bold" color="#453c72" mb={3}>
                          Your Current Plan Status
                        </Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">Active Plan</Typography>
                            <Typography variant="body1" fontWeight="bold" sx={{ 
                              color: userPlan.plan_name?.toLowerCase().includes('plus') ? "#1976d2" :
                                     userPlan.plan_name?.toLowerCase().includes('pro') ? "#9c27b0" :
                                     userPlan.plan_name?.toLowerCase().includes('unlimited') ? "#fbc02d" : "#757575",
                              fontSize: "18px"
                            }}>
                              {userPlan.plan_name || 'Free'}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">Billing Cycle</Typography>
                            <Typography variant="body1" sx={{ textTransform: 'capitalize', fontWeight: 'bold', fontSize: "18px" }}>
                              {!userPlan.billing_cycle || userPlan.billing_cycle === 'free' ? 'Free Plan' : userPlan.billing_cycle}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body2" color="textSecondary">Expiration Date</Typography>
                            <Typography variant="body1" fontWeight="bold" sx={{ fontSize: "18px" }}>
                              {userPlan.plan_expiry_date ? new Date(userPlan.plan_expiry_date).toLocaleDateString() : "Lifetime / No Expiry"}
                            </Typography>
                          </Grid>
                        </Grid>
                        
                        <Box sx={{ mt: 5, display: 'flex', justifyContent: 'center' }}>
                          <Button
                            variant="contained"
                            onClick={() => navigate(window.location.pathname.includes('/admin') ? '/admin/subscription' : '/subscription')}
                            sx={{
                              backgroundColor: "#453c72",
                              color: "white",
                              textTransform: "none",
                              fontWeight: "bold",
                              px: 4,
                              py: 1,
                              "&:hover": { backgroundColor: "#2b254a" }
                            }}
                          >
                            View Upgrade Options
                          </Button>
                        </Box>
                      </Box>
                    ) : (
                      <Typography>Loading plan details...</Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </div>
      </Box>
    </div>
    </>
  );
}
